const systems = [];

function Code(code) {
  //this.init = this.prepareInit(codes[0]);
  //this.func = this.prepareRest(codes.slice(1));
  code = code.replace(/var o_.*;/g, '');
  code = code.replace(/o_/g, 'this\.gameobjects\.data\.')
  this.code = code;
  this.func = new Function(code);
}

Code.prototype.execute = function (Util, gameobjects, dt) {
  const o = {
    gameobjects,
    dt,
    Util
  }
  this.func.call(o);
}

function System(codeBlocks) {
  if (codeBlocks.length > 1) {
    let init = [codeBlocks[0]];
    this.inited = false;
    this.initFunc = this.prepareCode(init);
    let rest = codeBlocks.slice(1);
    this.func = this.prepareCode(rest);
  } else {
    this.inited = true;
    this.func = this.prepareCode(codeBlocks);
  }
}

System.prototype.prepareCode = function (blocks) {
  const allCode = blocks.join('');
  return new Code(allCode);
}

System.prototype.execute = function (Util, gameobjects, dt) {
  if (!this.inited) {
    this.initFunc.execute(Util, gameobjects, dt);
    this.inited = true;
  }
  this.func.execute(Util, gameobjects, dt);
}

export default {
  System,
  Code
}
